import { useIntl } from '@edx/frontend-platform/i18n';
import PropTypes from 'prop-types';

import messages from './messages';
import { ArrowLeftSVG, ArrowRightSVG } from '../assets/svgs';

const ArrowButton = ({
  text,
  iconPosition,
  onClick,
  className,
  style,
}) => {
  const { formatMessage } = useIntl();

  const pageDirection = document.dir;

  return (
    <button className={`back-button ${className}`} type="button" style={style} onClick={onClick}>
      {iconPosition === 'right' && <img src={ArrowRightSVG} style={{ transform: pageDirection === 'ltr' ? 'scale(-1)' : 'scale(1)' }} alt="back-button" />}
      <span className="text-nowrap responsive-text">{text || formatMessage(messages['back.button'])}</span>
      {iconPosition === 'left' && (
        <img src={ArrowLeftSVG} style={{ transform: pageDirection === 'ltr' ? 'scale(-1)' : 'scale(1)' }} alt="back-button" />
      )}
    </button>
  );
};

ArrowButton.propTypes = {
  iconPosition: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.any,
};

ArrowButton.defaultProps = {
  iconPosition: 'right',
  text: '',
  className: '',
  style: {},
};

export default ArrowButton;
